import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { propType } from 'graphql-anywhere'
import { T, pathOr } from 'ramda'
import OnVisible from 'react-on-visible'

import GridTileOverlay from './grid-tile-overlay'
import TileBadge from '../shared/badge'
import TileRentalBadge from '../shared/rental-badge'
import Imgix from '../imgix'
import { getTileRecipe } from '../imgix/recipes'
import { getDetailsUrl } from '../../lib/utils'
import { useIsAuthenticated } from '../../hooks/use-is-authenticated'
import styles from './grid-tile.css'
import TILE_FRAGMENT from '../../../graphql/fragments/tile.gql'
import { dataLayerProductClick } from '../../lib/analytics/datalayer'

function GridTile({
  tile,
  theme,
  contentType,
  subType,
  listTitle,
  index,
  isOnMyList,
  addToMyList
}) {
  const isAuthenticated = useIsAuthenticated()
  const [isMouseHover, setIsMouseHover] = useState(false)
  const [isVisible, setIsVisible] = useState(false)

  const onMouseEnter = () => {
    setIsMouseHover(true)
  }

  const onMouseLeave = () => {
    setIsMouseHover(false)
  }

  const onVisibilityChange = () => {
    if (isVisible) {
      return
    }
    setIsVisible(true)
  }

  const hasBadge = Boolean(tile.badge)
  const tileRecipe = getTileRecipe(contentType, subType)
  const isRental = pathOr(false, ['contentItem', 'isRental'], tile)

  return (
    <div className={`${styles.tile} ${theme}`}>
      <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {hasBadge && (
          <TileBadge
            title={tile.badge}
            isRental={isRental}
            gridBadge
          />
        )}
        <Link
          to={getDetailsUrl(tile.contentItem)}
          data-lbx-e2e={tile.contentItem.path}
          onClick={() => dataLayerProductClick(tile.contentItem, index, listTitle, window.location.pathname)}
          className={styles.imgWrapper}
        >
          <Imgix src={tile.image} recipe={tileRecipe} className={styles.roundedBorder} />

          {isRental && (
            <TileRentalBadge isGrid />
          )}

          <GridTileOverlay
            tile={tile}
            display={isMouseHover}
            isAuthenticated={isAuthenticated}
            isOnMyList={isOnMyList}
            addToMyList={addToMyList}
          />
        </Link>
      </div>
      {!isVisible && <OnVisible onChange={() => onVisibilityChange()} />}
    </div>
  )
}

GridTile.propTypes = {
  tile: propType(TILE_FRAGMENT).isRequired,
  theme: PropTypes.string.isRequired,
  contentType: PropTypes.string,
  subType: PropTypes.string,
  listTitle: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isOnMyList: PropTypes.bool,
  addToMyList: PropTypes.func
}

GridTile.defaultProps = {
  contentType: null,
  subType: null,
  isOnMyList: false,
  addToMyList: T
}

export default GridTile
